/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { JobExecution } from '../../model/JobExecution';

/**
 * The comparison function to sort job executions by time added to queue (`timeQueued`).
 */
export const sortByTimeQueued = (a: JobExecution, b: JobExecution): number => {
  if (a.timeQueued < b.timeQueued) {
    return -1;
  }

  if (a.timeQueued > b.timeQueued) {
    return 1;
  }

  return 0;
};
